<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    <div class="card-header"><fa-icon [icon]="faBox"></fa-icon> {{ 'QUOTATION.CARGO' | translate }}</div>
    <div class="card-body">
      @if (enquiryFlight?.isFerryFlight) {
        <div class="alert alert-info text-center mb-0" [innerText]="'ENQUIRY_FLIGHT_EDIT.CARGO.IGNORED_FOR_FERRY' | translate"></div>
      }
      @if (enquiry?.type !== EnumEnquiryType.cargo) {
        <div
          class="alert alert-info text-center mb-0"
          >
          {{ 'ENQUIRY_FLIGHT_EDIT.CARGO.IGNORED_FOR_NON_CARGO' | translate }}
        </div>
      }
      @if (!enquiryFlight?.isFerryFlight && enquiry?.type === EnumEnquiryType.cargo) {
        <div
          class="row justify-content-center"
          >
          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="weight" [innerText]="'FLIGHT_BRIEF.WEIGHT' | translate"></label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  id="weight"
                  formControlName="weight"
                                [class.is-invalid]="
                                    (form.touched || weight.touched) && weight.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  min="0"
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched || weight.touched) &&
                    weight.errors &&
                    weight.errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <span class="input-group-text">kg</span>
              </div>
            </div>
            <div class="form-group">
              <label for="volume" [innerText]="'FLIGHT_BRIEF.VOLUME' | translate"></label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  id="volume"
                  formControlName="volume"
                                [class.is-invalid]="
                                    (form.touched || volume.touched) && volume.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  min="0"
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched || volume.touched) &&
                    volume.errors &&
                    volume.errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <span class="input-group-text">m³</span>
              </div>
            </div>
            <div class="form-group">
              <label for="awbNumber" [innerText]="'FLIGHT_BRIEF.AWB_NUMBERS' | translate"></label>
              <input
                id="awbNumber"
                type="text"
                class="form-control"
                formControlName="awbNumber"
                            [class.is-invalid]="
                                (form.touched || awbNumber.touched) &&
                                awbNumber.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
              <div class="invalid-tooltip">
                @if (
                  (form.touched || awbNumber.touched) &&
                  awbNumber.errors &&
                  awbNumber.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="typeOfCargo" [innerText]="'FLIGHT_BRIEF.CARGO_TYPE' | translate"></label>
              <input
                id="typeOfCargo"
                type="text"
                class="form-control"
                formControlName="typeOfCargo"
                            [class.is-invalid]="
                                (form.touched || typeOfCargo.touched) &&
                                typeOfCargo.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
              <div class="invalid-tooltip">
                @if (
                  (form.touched || typeOfCargo.touched) &&
                  typeOfCargo.errors &&
                  typeOfCargo.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
            <div class="form-group">
              <label for="nbPackages" [innerText]="'FLIGHT_BRIEF.NB_PACKAGES' | translate"></label>
              <div class="input-group">
                <input
                  id="nbPackages"
                  type="number"
                  min="0"
                  class="form-control"
                  formControlName="nbPackages"
                                [class.is-invalid]="
                                    (form.touched || nbPackages.touched) &&
                                    nbPackages.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched || nbPackages.touched) &&
                    nbPackages.errors &&
                    nbPackages.errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <span class="input-group-text" [innerText]="'FLIGHT_BRIEF.ITEMS' | translate"></span>
              </div>
            </div>
            <div class="form-group">
              <label for="customDeclaration" [innerText]="'FLIGHT_BRIEF.CUSTOMS_DECLARATION' | translate"></label>
              <input
                id="customDeclaration"
                type="text"
                class="form-control"
                formControlName="customDeclaration"
                            [class.is-invalid]="
                                (form.touched || customDeclaration.touched) &&
                                customDeclaration.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                />
              <div class="invalid-tooltip">
                @if (
                  (form.touched || customDeclaration.touched) &&
                  customDeclaration.errors &&
                  customDeclaration.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="deliveryCargoHoursBeforeDeparture" [innerText]="'ENQUIRY_FLIGHT_EDIT.CARGO.DELIVERY_LIMIT_HOURS_LABEL' | translate"></label>
              <div class="input-group">
                <input
                  id="deliveryCargoHoursBeforeDeparture"
                  type="number"
                  min="0"
                  class="form-control"
                  formControlName="deliveryCargoHoursBeforeDeparture"
                                [class.is-invalid]="
                                    (form.touched || deliveryCargoHoursBeforeDeparture.touched) &&
                                    deliveryCargoHoursBeforeDeparture.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched ||
                    deliveryCargoHoursBeforeDeparture.touched) &&
                    deliveryCargoHoursBeforeDeparture.errors &&
                    deliveryCargoHoursBeforeDeparture.errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <span class="input-group-text" [innerText]="'GENERAL.HOURS_SHORT' | translate"></span>
              </div>
            </div>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                formControlName="dgd"
                id="dgd"
                />
              <label class="form-check-label" for="dgd" [innerText]="'FLIGHT_BRIEF.DGD' | translate"></label>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="form.disabled"
        (click)="prev()"
        >
        <fa-icon [icon]="faArrowLeft"></fa-icon>
        {{ 'GENERAL.PREVIOUS' | translate }}
      </button>
    </div>
    <div class="col text-end">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="form.disabled || !form.valid"
        (click)="saveAndNext()"
        >
        {{ 'GENERAL.NEXT' | translate }}
        <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>
</form>
